import { Component, EventEmitter, inject, Output } from '@angular/core';
import { CredentialsService } from '@auth';
import { GetHeadlineOption } from '@core/utils';
import { HeadlineType } from '@core/enums';

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.scss'],
  standalone: false,
})
export class TopBarComponent {
  @Output() openSideBar = new EventEmitter<boolean>();
  private readonly _credentialsService = inject(CredentialsService);

  get isHeadlineStandard(): boolean {
    return GetHeadlineOption() === HeadlineType.STANDARD;
  }

  get logoUrl(): string | null {
    const credentials = this._credentialsService.credentials;
    if (!credentials || !credentials?.club) window.location.href = '/logout';
    return credentials ? credentials?.club?.logoUrl : null;
  }

  toggleAside() {
    this.openSideBar.emit(true);
  }
}
